import { render } from "./Modal.vue?vue&type=template&id=50ff78a2&scoped=true&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=50ff78a2&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ff78a2"]])

export default __exports__